import React from 'react';
import { makeStyles } from '@material-ui/styles';

import { Typography, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: theme.spacing(4),
  },
  instructions: {
    ...theme.typography.subtitle2,
    color: green[500],
  },
  formGroupGrid: {
    paddingTop: theme.spacing(4),
  },
}));

const RegistrationSuccess = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Box component="div">
        <Typography className={classes.instructions}>{t('registration_success')}</Typography>
      </Box>
    </div>
  );
};

export default RegistrationSuccess;
